import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { usePosContext } from "../context/pos-context";

const KHR_RATE = 4050;

type PosCartBarProps = {
  className?: string;
};

export function PosCartBar({ className }: PosCartBarProps) {
  const { cart, handleViewCart } = usePosContext();
  const { itemCount, subtotal } = cart;

  const subtotalKhr = Math.round(subtotal * KHR_RATE);

  return (
    <button
      type="button"
      onClick={handleViewCart}
      className={cn(
        "w-full flex items-center justify-between px-6 py-4 bg-primary text-primary-foreground rounded-t-2xl shadow-lg flex-shrink-0 touch-none",
        className
      )}
    >
      <div className="text-left">
        <p className="text-sm font-medium opacity-90">View your cart</p>
        <p className="text-base font-semibold">
          {itemCount} {itemCount === 1 ? "Item" : "Items"}
        </p>
      </div>
      <ChevronDown className="h-8 w-8 opacity-90" />
      <div className="text-right">
        <p className="text-sm font-medium opacity-90">
          {subtotalKhr.toLocaleString("en-KH")} ៛
        </p>
        <p className="text-base font-semibold">${subtotal.toFixed(2)}</p>
      </div>
    </button>
  );
}
